import { Text } from '@heathmont/moon-core';
import { rem } from '@heathmont/moon-utils';
import styled from 'styled-components';
import CloseButton from '~/client/shared/CloseButton';
import Translate from '~/client/shared/i18n/Translate';
import Stack from '~/client/shared/Stack';
import NotificationsError from '@/external/icons/NotificationsError';

type Props = {
  handleClose: () => void;
};
const InvalidCredentialsBox: FC<Props> = ({ handleClose }) => (
  <LoginErrorBox>
    <IconWrapper>
      <NotificationsError fontSize={rem(40)} color="chiChi.100" />
    </IconWrapper>
    <Wrapper>
      <Text isBold size={14}>
        <Translate id="profile.unable_to_login" />
      </Text>
      <Text size={12}>
        <Translate id="errors.INVALID_USERNAME_PASSWORD_OR_OTP" />
      </Text>
    </Wrapper>
    <Stack alignSelf="flex-start" margin="0 0 0 auto">
      <CloseButton onClick={handleClose} fontSize={18} color="bulma.100" />
    </Stack>
  </LoginErrorBox>
);

const Wrapper = styled(Stack)`
  && {
    overflow-wrap: break-word;
    max-width: ${rem(190)};
    grid-gap: initial;
    align-self: center;
  }
`;

const LoginErrorBox = styled(Stack)`
  && {
    background-color: #ff4e6432;
    border-radius: ${rem(8)};
    height: ${rem(72)};
    padding: ${rem(16)};
    display: flex;
    flex-direction: row;
  }
`;

const IconWrapper = styled(Stack)`
  && {
    border-radius: ${rem(8)};
    height: ${rem(40)};
    width: ${rem(40)};
    background-color: #ff4e6432;
  }
`;

export default InvalidCredentialsBox;
